import { FiCheckCircle } from "react-icons/fi";

interface SuccessScreenProps {
  email?: string;
  accentColor: string;
  textColor: string;
  onClose: () => void;
}

function SuccessScreen({
  email,
  accentColor,
  textColor,
  onClose,
}: SuccessScreenProps) {
  return (
    <>
      <div className="flex flex-1 flex-col items-center justify-center px-6 py-8 text-center">
        <div
          className="mb-6 flex h-20 w-20 sm:h-24 sm:w-24 items-center justify-center rounded-full shadow-lg"
          style={{ backgroundColor: `${accentColor}20` }}
        >
          <FiCheckCircle size={48} style={{ color: accentColor }} />
        </div>
        <h4 className="mb-3 text-xl sm:text-2xl font-bold text-black dark:text-white">
          Tudo certo! 🎉
        </h4>
        <p className="text-sm sm:text-base text-gray-600 dark:text-gray-300 max-w-md">
          Seu agendamento foi confirmado com sucesso. Enviamos um e-mail de
          confirmação{email ? ` para ${email}` : ""}.
        </p>
        <p className="mt-3 text-xs sm:text-sm text-gray-500 dark:text-gray-400">
          Verifique sua caixa de entrada e também a pasta de spam.
        </p>
      </div>
      <div className="border-t border-stroke bg-white px-4 sm:px-6 py-4 dark:border-strokedark dark:bg-boxdark">
        <button
          type="button"
          onClick={onClose}
          className="w-full rounded-xl py-3.5 sm:py-4 text-sm sm:text-base font-semibold text-white transition-all hover:opacity-90 shadow-lg"
          style={{ backgroundColor: accentColor, color: textColor }}
        >
          Fechar
        </button>
      </div>
    </>
  );
}

export default SuccessScreen;
